import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { TIP_BAR_HEIGHT } from "../shared/constants";

export default class ZoomMenu extends AbstractProvidedClass {
    init() {
        this.container = this.p.createDiv().parent('#p5canvas');
        this.position();

        // Zoom in
        this.p.createButton('<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#zoom-in-line"></use></svg>')
            .parent(this.container)
            .class('btn-icon-bright')
            .attribute('title', 'Zoom in')
            .mousePressed(() => this.view.zoomIn());

        // Zoom out
        this.p.createButton('<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#zoom-out-line"></use></svg>')
            .parent(this.container)
            .position(0, 40)
            .class('btn-icon-bright')
            .attribute('title', 'Zoom out')
            .mousePressed(() => this.view.zoomOut());
    }

    position() {
        this.container.position(this.sideBar.x - 50, this.p.height - (125 + TIP_BAR_HEIGHT));
    }
}
